// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.push([module.id, "@import url(https://use.typekit.net/fes4uhy.css);"]);
// Module
exports.push([module.id, "@media (min-width:769px){.filter-dropdown__overlay--container{left:50%;top:20px;right:unset;bottom:unset;width:80%;transform:translate(-50%);padding:20px 30px;border-radius:10px}}", ""]);
// Exports
module.exports = exports;
